<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9L7 4L2 9"
      stroke="currentColor"
      stroke-linecap="round"
    />
  </svg>
</template>